import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["WhosAttending","WhosHosting"] */ "/vercel/path0/src/app/e/[eventId]/_components/WhoIsComing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/rsvp/RSVPModalStepControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/events-components/EventChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventImage"] */ "/vercel/path0/src/components/v3/events-components/EventImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventImageBadgeOverlay"] */ "/vercel/path0/src/components/v3/events-components/EventImageOverlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventTag"] */ "/vercel/path0/src/components/v3/events-components/EventTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventLocationName"] */ "/vercel/path0/src/components/v3/events-components/EventViewAndEdit/EventLocation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/events-components/ShareEventLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FollowButton"] */ "/vercel/path0/src/components/v3/follow/FollowButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/src/components/v3/shadcn/Tooltip.tsx");
